// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-P":"P_shp2-detail-P__OZPdV"};